import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'GrxSwap',
  description:
    'The most popular AMM on GRX Chain by user count! Trade tokens, provide liquidity, and earn rewards on a platform you can trust.',
  image: 'https://grxscan.io/assets/configs/network_logo.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
    basePath = '/voting/proposal'
  } else if (path.startsWith('/nfts/collections')) {
    basePath = '/nfts/collections'
  } else if (path.startsWith('/nfts/profile')) {
    basePath = '/nfts/profile'
  } else if (path.startsWith('/pancake-squad')) {
    basePath = '/pancake-squad'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `${t('Home')} | ${t('GrxSwap')}`,
      }
    case '/swap':
      return {
        title: `${t('Exchange')} | ${t('GrxSwap')}`,
      }
    case '/add':
      return {
  title: `${t('Add Liquidity')} | ${t('GrovX Chain')}`,
      }
    case '/remove':
      return {
  title: `${t('Remove Liquidity')} | ${t('GrovX Chain')}`,
      }
    case '/liquidity':
      return {
  title: `${t('Liquidity')} | ${t('GrovX Chain')}`,
      }
    case '/find':
      return {
  title: `${t('Import Pool')} | ${t('GrovX Chain')}`,
      }
    case '/competition':
      return {
  title: `${t('Trading Battle')} | ${t('GrovX Chain')}`,
      }
    case '/prediction':
      return {
  title: `${t('Prediction')} | ${t('GrovX Chain')}`,
      }
    case '/prediction/leaderboard':
      return {
  title: `${t('Leaderboard')} | ${t('GrovX Chain')}`,
      }
    case '/farms':
      return {
  title: `${t('Farms')} | ${t('GrovX Chain')}`,
      }
    case '/farms/auction':
      return {
  title: `${t('Farm Auctions')} | ${t('GrovX Chain')}`,
      }
    case '/pools':
      return {
  title: `${t('Pools')} | ${t('GrovX Chain')}`,
      }
    case '/lottery':
      return {
  title: `${t('Lottery')} | ${t('GrovX Chain')}`,
      }
    case '/ifo':
      return {
  title: `${t('Initial Farm Offering')} | ${t('GrovX Chain')}`,
      }
    case '/teams':
      return {
  title: `${t('Leaderboard')} | ${t('GrovX Chain')}`,
      }
    case '/voting':
      return {
  title: `${t('Voting')} | ${t('GrovX Chain')}`,
      }
    case '/voting/proposal':
      return {
        title: `${t('Proposals')} | ${t('GrxSwap')}`,
      }
    case '/voting/proposal/create':
      return {
        title: `${t('Make a Proposal')} | ${t('GrxSwap')}`,
      }
    case '/info':
      return {
        title: `${t('Overview')} | ${t('GrxSwap Info & Analytics')}`,
        description: 'View statistics for GrxSwap exchanges.',
      }
    case '/info/pools':
      return {
        title: `${t('Pools')} | ${t('GrxSwap Info & Analytics')}`,
        description: 'View statistics for GrxSwap exchanges.',
      }
    case '/info/tokens':
      return {
        title: `${t('Tokens')} | ${t('GrxSwap Info & Analytics')}`,
        description: 'View statistics for GrxSwap exchanges.',
      }
    case '/nfts':
      return {
  title: `${t('Overview')} | ${t('GrovX Chain')}`,
      }
    case '/nfts/collections':
      return {
  title: `${t('Collections')} | ${t('GrovX Chain')}`,
      }
    case '/nfts/activity':
      return {
  title: `${t('Activity')} | ${t('GrovX Chain')}`,
      }
    case '/nfts/profile':
      return {
  title: `${t('Profile')} | ${t('GrovX Chain')}`,
      }
    case '/pancake-squad':
      return {
  title: `${t('Pancake Squad')} | ${t('GrovX Chain')}`,
      }
    default:
      return null
  }
}
